export interface HFConfig {
  sticky: boolean;
  headerWrapper: HTMLElement | null;
  isSupportSite: boolean; // field added for integration with support.wix.com. Should be fixed after experiment win.
  languageRedirectUrl: LanguageRedirectUrl | undefined;
  hideMainLinksOnDesktop: boolean;
  language: string;
  baseUrl: string;
  postLogin: string;
  postSignUp: string;
}

export type LanguageRedirectUrl = (param: { language: string }) => string;

const defaultConfig: HFConfig = {
  sticky: true,
  headerWrapper: null,
  isSupportSite: false,
  hideMainLinksOnDesktop: false,
  languageRedirectUrl: undefined,
  baseUrl: getDefaultBaseUrl(),
  language: 'en',
  postLogin: 'https://www.wix.com/my-account/sites/',
  postSignUp: 'https://www.wix.com/new/intro/',
};

export function getConfig(config?: Partial<HFConfig>): HFConfig {
  if (config) {
    return {
      ...defaultConfig,
      ...config,
    };
  }
  return defaultConfig;
}

function getDefaultBaseUrl() {
  const version = typeof window !== 'undefined' && typeof window.WIX_HF_VERSION === 'string' ? `${window.WIX_HF_VERSION}` : '';
  return `//static.parastorage.com/services/header-footer-wix-statics/${version}/`;
}
